import React, { Component } from "react";
import { draggable, URL } from "../../utils/Constants";
import { displayMessage } from "../../utils/Utils";
import Swal from "sweetalert2";
import { axiosPost } from "../../utils/AxiosApi";
import swal from "@sweetalert/with-react";
import Snackbar from "@material-ui/core/Snackbar";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash } from "@fortawesome/free-solid-svg-icons";

class UpdatePasswordModal extends Component {
  state = {
    password: null,
    confirmPassword: null,
    linkCopied: false,
    showPassword: {
      password: false,
      confirmPassword: false,
    },
  };

  handleChange = (e) => {
    this.setState({ [e.target.name]: e.target.value });
  };

  validatePassword = () => {
    let error = 0;
    // let validateRegex = /^(?=(.*[a-z]){1,})(?=(.*[\d]){1,})(?=(.*[\W]){1,})(?!.*\s).{8,}$/;
    const validateRegex = "^(?=.*[0-9])(?=.*[A-Z])(?=.*[a-z]).{8,}$";
    let ps = this.state.password;

    if (ps === null || ps.trim().length === 0) return;

    if (ps && (ps !== "" || ps !== null)) {
      if (ps.match(validateRegex)) {
        error = 0;
      } else {
        error++;
      }
    }
    if (error > 0 || ps.length < 8) {
      let texts = `<p>Password should have<br><ol>
      <li>One numeric</li>
      <li>One uppercase</li>
      <li>One lowercase</li>
      <li>At least 8 characters</li>
      </ol></p>`;
      Swal.fire({
        title: "Oops",
        html: texts,
        allowOutsideClick: false,
        closeOnClickOutside: false,
      });
      draggable();
    }
  };

  copyToClipboard = (data) => {
    let dummy1 = document.createElement("input");
    document.body.appendChild(dummy1);
    dummy1.setAttribute("value", data);
    dummy1.select();
    document.execCommand("copy");
    document.body.removeChild(dummy1);
  };

  renderLinkCopyText = () => {
    this.setState({ linkCopied: true });
  };

  handleChangePassword = () => {
    if (this.state.password !== null && this.state.confirmPassword !== null) {
      if (this.state.password === this.state.confirmPassword) {
        axiosPost(
          URL.updateForgetPassword,
          {
            password: this.state.password,
            username: this.props.selectedUsername,
            // id: this.props.selectedId,
          },
          (response) => {
            if (response.status === 200) {
              const username = response.data.data.username;
              const password = response.data.data.password;
              swal({
                title: `Password Updated`,
                content: (
                  <div>
                    New user with username: {username} and password: {password}{" "}
                    has been created.
                    <br></br>
                    <button
                      className="tt-button tt-button-primary"
                      onClick={() => {
                        this.copyToClipboard(
                          `Username: ${username}, Password: ${password}`,
                        );
                        this.renderLinkCopyText();
                      }}
                    >
                      {this.state.linkCopied
                        ? "Copied"
                        : "Copy Username and Password"}
                    </button>
                  </div>
                ),
              });
              this.props.toggleForgotModal();
              this.props.getForgetPasswordUsers();
              this.props.getAllUsers();
            } else {
              displayMessage(
                "Oops",
                "There was an error updating your password. Please try again.",
              );
            }
          },
        );
      } else {
        swal({
          title: "Oops",
          text: "New Password and Confirm Password do not match. Please re-check and submit again.",
          closeOnClickOutside: false,
          allowOutsideClick: false,
        });
        draggable();
      }
    } else {
      displayMessage("Oops", "Please enter passwords on both fields.");
    }
  };

  render() {
    return (
      <div>
        <Snackbar
          anchorOrigin={{
            vertical: "bottom",
            horizontal: "left",
          }}
          open={this.state.linkCopied}
          autoHideDuration={1000}
          onClose={() => this.setState({ linkCopied: false })}
          message="Copied to Clipboard"
        />

        <div className="row mb-2">
          <div className="col-md-4">
            <label>
              <strong>New password: </strong>
            </label>
          </div>
          <div className="col-md-8 password-input">
            <input
              id="pass"
              type={this.state.showPassword.password ? "text" : "password"}
              name="password"
              value={this.state.password}
              className="form-control"
              onChange={this.handleChange}
              onBlur={this.validatePassword}
            />
            <button
              className="eye-btn"
              onClick={() =>
                this.setState((prevState) => ({
                  showPassword: {
                    ...prevState.showPassword,
                    password: !prevState.showPassword.password,
                  },
                }))
              }
            >
              {this.state.showPassword.password ? (
                <FontAwesomeIcon icon={faEye} />
              ) : (
                <FontAwesomeIcon icon={faEyeSlash} />
              )}
            </button>
          </div>
        </div>
        <div className="row mb-3">
          <div className="col-md-4">
            <label>
              <strong>Confirm password: </strong>
            </label>
          </div>
          <div className="col-md-8 password-input">
            <input
              type={
                this.state.showPassword.confirmPassword ? "text" : "password"
              }
              name="confirmPassword"
              value={this.state.confirmPassword}
              className="form-control"
              onChange={this.handleChange}
            />
            <button
              className="eye-btn"
              onClick={() =>
                this.setState((prevState) => ({
                  showPassword: {
                    ...prevState.showPassword,
                    confirmPassword: !prevState.showPassword.confirmPassword,
                  },
                }))
              }
            >
              {this.state.showPassword.confirmPassword ? (
                <FontAwesomeIcon icon={faEye} />
              ) : (
                <FontAwesomeIcon icon={faEyeSlash} />
              )}
            </button>
          </div>
        </div>
        <div className="row mt-1 mb-2">
          <div className="col text-right">
            <button
              className="tt-button tt-button-primary change-password"
              onClick={this.handleChangePassword}
            >
              Update password
            </button>
          </div>
        </div>
      </div>
    );
  }
}

export default UpdatePasswordModal;
